// @flow
import React, { type Node } from 'react';
import { Splash } from 'Browser/cast/receiver/Splash';
import { Spinner } from 'Browser/cast/receiver/Spinner';
import { StatusWidget as styles } from 'Browser/cast/receiver/styles';
import { MetadataViewer } from 'Browser/cast/receiver/MetadataViewer';
import type { Metadata } from 'Common/cast/types';

const DEFAULT_ERROR_MESSAGE = 'An unknown error has occurred. Please try again later.';

const Idle = () => <Splash />;

const Container = ({ children }: { children: Node }) => (
  <div style={styles.container} className="App-header">
    {children}
  </div>
);

const Error = ({ message = DEFAULT_ERROR_MESSAGE }: { message?: string }) => (
  <Container>
    <p style={styles.status}>{message}</p>
  </Container>
);

const Connecting = ({ to, metadata }: { to?: string, metadata?: ?Metadata }) => (
  <Container>
    {metadata && <MetadataViewer mode="full_poster" metadata={metadata} />}
    <Spinner />
    <p style={styles.status}>{to ? `Connecting to "${to}"` : 'Connecting'}</p>
  </Container>
);

const StartingStreaming = ({ metadata }: { metadata?: ?Metadata }) => (
  <Container>
    {metadata && <MetadataViewer mode="full_poster" metadata={metadata} />}
    <Spinner />
    <p style={styles.status}>Starting streaming</p>
  </Container>
);

const StoppingStreaming = () => (
  <Container>
    <Spinner />
    <p style={styles.status}>Stopping streaming</p>
  </Container>
);

const ChangingChannel = () => (
  <Container>
    <Spinner />
    <p style={styles.status}>Tuning...</p>
  </Container>
);

const Seeking = () => (
  <Container>
    <Spinner />
    <p style={styles.status}>Seeking...</p>
  </Container>
);

const Disconnecting = () => (
  <Container>
    <Spinner />
    <p style={styles.status}>Disconnecting...</p>
  </Container>
);

const Loading = ({ metadata }: { metadata?: Metadata }) => (
  <Container>
    {metadata && <MetadataViewer mode="full_poster" metadata={metadata} />}
    <Spinner />
    <p style={styles.status}>Loading...</p>
  </Container>
);

export { Container };
export const CommonUi = {
  Idle,
  Error,
  Connecting,
  StartingStreaming,
  StoppingStreaming,
  ChangingChannel,
  Seeking,
  Disconnecting,
  Loading,
};
